const enMessages = {
  /* 01.General */
  'general.copyright': 'Sistema Nube © All Rights Reserved.',
  'general.choose-option': 'Choose',
  'general.january': 'January',
  'general.february': 'February',
  'general.march': 'March',
  'general.april': 'April',
  'general.may': 'May',
  'general.june': 'June',
  'general.july': 'July',
  'general.august': 'August',
  'general.september': 'September',
  'general.october': 'October',
  'general.november': 'November',
  'general.december': 'December',
  'general.date': 'Date',
  'general.code': 'Code',
  'general.discount': 'Discount',
  'general.discountType': 'Type',
  'general.couponType': 'Coupon Type',
  'general.since': 'Valid from',
  'general.until': 'Valid until',
  'general.state': 'State',
  'general.amount': 'Amount',
  'general.save': 'Save',
  'general.points': 'Points',
  'general.datetime': 'Datetime',
  'general.type': 'Type',
  'general.detail': 'Detail',
  'general.actions': 'Actions',
  'general.adhered': 'Adhered',
  'general.businesses': 'Businesses',
  'general.destinations': 'Destinations',
  'general.all': 'All',
  'general.all-2': 'All',
  'general.pay': 'Pay',
  'general.entities': 'Agencies',
  'general.name': 'Name',
  'general.number': 'Number',
  'general.expiration': 'Expiration date',

  /* 02.User Login, Logout, Register */

  'user.forgot-password-text':
    '<b> Attention! </b> A temporary password will be sent to the email with which you have registered. If you have not registered, go to the Registration section.',
  'user.forgot-password': 'Forgot Password',
  'user.forgot-password-email': 'Complete your email',
  'user.reset-password-button': 'I want my password',
  'user.forgot-password-title': 'Retrieve my password',

  'user.reset-password-title': 'Reset Password',
  'user.reset-password-text': 'Choose your new password to log in with your user',
  'user.new-password-again': 'New Password Again',
  'user.new-password': 'New Password',
  'user.reset-password': 'Reset Password',
  'user.new-password-label': 'Complete your new password',

  'user.login-title': 'Login',
  'user.login-password-text': 'Complete your credentials and start enjoying all the benefits',
  'user.login-button': 'Login',

  'user.register': 'Register',
  'user.register-text': 'Complete your details and start enjoying all the benefits',
  'user.fullname': 'Name and surname',
  'user.cellphone': 'Mobile number',
  'user.birthday': 'Birthdate',
  'user.day': 'Day',
  'user.month': 'Month',
  'user.year': 'Year',
  'user.document-type': 'Document Type',
  'user.document': 'ID number',
  'user.gender': 'Gender',
  'user.accept': 'I accept the',
  'user.terms': '<b>term and conditions</b>',
  'user.email': 'E-mail',
  'user.card': 'Card number',
  'user.password': 'Password',
  'user.forgot-password-question': 'Forget password?',
  'user.logout': 'Logout',
  'user.login': 'Login',
  'user.register-button': 'Create account',
  'user.recommendationCode': 'Código para referir',
  'user.refererCodeSponsor': 'Código de recomendación',

  'user.tooltip-document': 'Digits only, no blanks or signs',
  'user.tooltip-disabled-document':
    'If your data is incorrect, you must request a manual update at our site',
  'user.tooltip-password': 'The password must be between 6 and 11 alphanumeric characters',
  'user.male': 'Male',
  'user.female': 'Female',
  'user.not-defined': 'Not specific',

  'topnav.userLogged.my-account': 'My Account',
  'topnav.userLogged.my-card': 'My Card',
  'topnav.userLogged.my-money': 'My Money',
  'topnav.userLogged.my-discounts': 'My Discounts',
  'topnav.userLogged.my-vouchers': 'My Vouchers',
  'topnav.userLogged.my-activity': 'My Activity',
  'topnav.userLogged.my-giftcards': 'My Giftcards',
  'topnav.terms': 'Term and Conditions',
  'topnav.use-coupon': 'Use coupon',

  /* 03.Menu */
  'menu.home': 'Home',
  'menu.discounts': 'Discounts',
  'menu.awards': 'Awards',
  'menu.adheredBusinesses': 'Businesses',
  'menu.destinations': 'Destinations',
  'menu.infoPage': 'Informação',

  /* 04.Home */
  'home.latest-awards': 'Latest Awards',
  'home.latest-discounts': 'Latest Discounts',
  'home.adhered-businesses': 'Adhered Businesses',
  'home.adhered-destinations': 'Adhered Destinations',

  /* 05.Cards */
  'cards.user.welcome': 'Welcome',
  'cards.user.points': 'Points',
  'cards.user.money': 'Money',
  'cards.user.gameCoins': 'Game Coins',

  /* 06.Benefits */
  'benefits.categories': 'Categories',
  'benefits.adheredBusinesses': 'Adhered Businesses',
  'benefits.destinations': 'Adhered Destinations',
  'benefits.discounts': 'Discounts',
  'benefits.awards': 'Awards',

  /* 07.Benefit Details */
  'benefit-details.details': 'Details',
  'benefit-details.description': 'Description',
  'benefit-details.adheredBusiness': 'Adhered Business',
  'benefit-details.destination': 'Adhered Destination',
  'benefit-details.category': 'Category',
  'benefit-details.without-category': 'Without category',
  'benefit-details.stock': 'Stock',
  'benefit-details.required-points': 'Required points',
  'benefit-details.required-money': 'Required money',
  'benefit-details.points': 'Points',

  /* 08.Social Media */
  'social-media.whatsapp': 'Whatsapp',
  'social-media.facebook': 'Facebook',
  'social-media.button-facebook': 'Continue with Facebook',
  'social-media.google-map': 'Google Map',
  'social-media.instagram': 'Instagram',
  'social-media.website': 'Website',

  /* 09.Validations */
  'validations.required': 'It is required',
  'validations.email-required': 'The email is required',
  'validations.password-required': 'Password is required',
  'validations.email': 'Invalid email format',
  'validations.min': 'Must be at least {min} characters',
  'validations.max': 'Must have maximum {max} characters',
  'validations.accept-terms': 'You must accept the terms and conditions',
  'validations.accept-oneOf': 'You must choose one of these values: ',
  'validations.award-points': 'You do not have enough points to obtain this award',
  'validations.award-money': 'You do not have enough money to get this prize',
  'validations.discount-points': 'You do not have enough points to obtain this discount',
  'validations.discount-money': 'You do not have enough money to get this discount',
  'validations.pay-money-required': 'You must complete the amount to pay',
  'validations.pay-money': 'You cannot pay an amount that you do not have',
  'validations.money-points': 'You have no points to change',
  'validations.money-slide': 'You must swipe to redeem your points',
  'validations.money-selected-points': 'You do not have the selected points to change',

  /* 10.Success Messages */
  'success-messages.password-sent': 'The password has been sent!',
  'success-messages.check-email': 'Check email account {email}',
  'success-messages.award-exchanged': 'Redeemed award',
  'success-messages.coupon-saved': 'Discount obtained',
  'success-messages.coupon-used': 'Used coupon',
  'success-messages.voucher-saved': 'Generated Voucher',
  'success-messages.voucher-downloaded': 'Downloaded voucher',
  'success-messages.money-loaded': 'Loaded Money',
  'success-messages.ok': 'Was saved successfully',

  /* 11.Error Pages */
  'error-pages.404-title': '404: Club not found',
  'error-pages.inactive-title': 'Inactive Site',

  /* 12.Error Messages */
  'error-messages.nok': 'An error has occurred',

  /* 13.Award Exchanges */
  'award-exchange.button': 'Exchange',

  /* 14.Coupons */
  'coupons.button': 'Obtain',
  'coupons.valid-since': 'Coupon valid from',
  'coupons.valid-until': 'until',
  'coupons.code': 'Coupon code',
  'coupons.show-in-commerce': 'Show in box',
  'coupons.qr-text': 'If the QR is scanned, the coupon will be used. It will be definitely lost.',
  'coupons.exchange-online': 'Online redemption',
  'coupons.code-copy':
    'Copy the coupon code and paste it to obtain the corresponding discount on the purchase.',
  'coupons.use': 'Use',
  'coupons.use-later': 'Use later',

  /* 15.Money */
  'money.exchange-points': 'Redeem points for money',
  'money.pay': 'Pay with my money',
  'money.show-voucher': 'Show voucher',

  /* 16.Activity */
  'activity.monthly-purchases': 'Monthly Purchases',
  'activity.my-interactions': 'Latest interactions',

  /* 17.Profile */
  'profile.summary': 'Summary',
  'profile.personal-data': 'Personal Data',
  'profile.account-data': 'Account Data',
  'profile.current-money': 'Current money',
  'profile.accumulated-points': 'Accumulated points',

  /* 18.Datatable */
  'datatable.processing': 'Processing...',
  'datatable.zero-records': 'No results found',
  'datatable.empty-table': 'No data available in this table',
  'datatable.loading': 'Loading...',

  /* 19.Membership */
  'membership.title': 'You must activate your membership',
  'membership.title-mp': 'Activate your membership',
  'membership.text':
    'Your user is in status <b> Pending payment </b>. In order to use the platform with all its benefits, you must pay the membership.',
};

export default enMessages;
